import { QuestionCircleOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { Tooltip } from 'antd';
import { Card } from 'antd';
import React, { useState } from 'react';
import TimezoneSelectFormItem from './TimezoneSelect';
import { Form } from 'antd';
import { DatePicker } from 'antd';
import { syncTimeFieldsToTimezone } from '../../utils';

export const DateRangeSelectorFormItem = ( {
    form,
    startEnabled = true, startRequired = true, startName = 'startAt', //startAfterNow = false, TODO enforce start date must be after now
    endEnabled = true, endRequired = true, endName = 'endAt',
    helpMessage,
    disabled,
    validateTab,
} ) => {

    // just for tracking previous timezone
    const [ selectedTimezone, setSelectedTimezone ] = useState( form.getFieldValue( 'timezone' ) );
    
    function onTimezoneChange( tz ) {
        const prevTz = selectedTimezone;

        if ( !prevTz || prevTz === tz ) {
            return;
        }
        
        setSelectedTimezone( tz );

        syncTimeFieldsToTimezone( prevTz, tz, [ startName, endName ], form );
        validateTab();
    }

    return (
        <Card
            size="small"
            title={ 'Date Range' }
            extra={ helpMessage && <Tooltip title={ helpMessage } ><QuestionCircleOutlined /></Tooltip> }
        >
            <Space direction='vertical'>

                <Space.Compact>
                    <TimezoneSelectFormItem disabled={ disabled } onChange={ onTimezoneChange } />
                </Space.Compact>
                <Space size='large'>
                    { startEnabled && 
                        <Form.Item
                            label='Start Date'
                            name={ startName }
                            dependencies={ [ 'timezone' ] }
                            rules={ [
                                {
                                    required: startRequired,
                                    message: 'Start Date is required'
                                }
                            ] }
                        >
                            <DatePicker
                                showNow={ false }
                                showTime={ {
                                    minuteStep: 5  
                                } } 
                                disabled={ disabled } 
                                format='LLL' 
                                style={ { 'min-width': 250 } } 
                                onChange={ validateTab } />
                        </Form.Item>
                    }

                    { endEnabled && 
                        <Form.Item
                            label='End Date'
                            name={ endName }
                            dependencies={ [ startName, 'timezone' ] }
                            rules={ [
                                {
                                    required: endRequired,
                                    message: 'End Date is required'
                                },
                                ( { getFieldValue } ) => ( {
                                    validator( _, value ) {
                                        const startDate = getFieldValue( startName );

                                        if ( !startDate || !value || startDate.isBefore( value ) ) {
                                            return Promise.resolve();
                                        }
                                        if ( endRequired ) {
                                            return Promise.reject( new Error( 'End Date must be after Start Date' ) );
                                        } else {
                                            return Promise.reject( new Error( 'End Date must be unset or after Start Date' ) );
                                        }
                                    },
                                } )
                            ] }
                        >
                            <DatePicker
                                showNow={ false }
                                showTime={ {
                                    minuteStep: 5  
                                } } 
                                disabled={ disabled } 
                                format='LLL' 
                                style={ { 'min-width': 250 } } 
                                onChange={ validateTab } />
                        </Form.Item>
                    }
                </Space>
            </Space>

        </Card>
    );
};